
export const ForecastPeriodSection = ({
    type,
    setType
}) => {
    return (
        <div className="space-y-3">
            <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                Forecast Period
            </label>
            <div className="flex items-center gap-2 justify-start">
                <button 
                    className={`${type === "month" ? "border-blue-300 text-blue-900 bg-blue-100" : ""} inline-flex items-center border border-gray-300 justify-center rounded-md text-sm font-medium transition-colors h-10 px-3`}
                    onClick={() => setType?.("month")}
                >
                    By Month
                </button>
                <button 
                    className={`${type === "year" ? "border-green-300 text-green-900 bg-green-100" : ""} inline-flex items-center border border-gray-300 justify-center rounded-md text-sm font-medium transition-colors h-10 px-3`}
                    onClick={() => setType?.("year")}
                >
                    By Year
                </button>
            </div>
        </div>
    )
}